import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UiService } from 'src/app/services/core/ui.service';
import { DemoPrescriptionComponent } from './demo-prescription/demo-prescription.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/interfaces/common/user.interface';
import { Router } from '@angular/router';
import { FileUploadService } from 'src/app/services/gallery/file-upload.service';
import { UserDataService } from 'src/app/services/common/user-data.service';
import { PrescriptionOrder } from 'src/app/interfaces/common/prescription-order';
import { PrescriptionOrderService } from 'src/app/services/common/prescription-order.service';
import { UserService } from 'src/app/services/common/user.service';
import { AddressComponent } from '../address/address.component';
import { ReloadService } from 'src/app/services/core/reload.service';
import { Address } from 'src/app/interfaces/common/address.interface';
import { Subscription } from 'rxjs';
import {UtilsService} from "../../../services/core/utils.service";

@Component({
  selector: 'app-upload-prescription-popup',
  templateUrl: './upload-prescription-popup.component.html',
  styleUrls: ['./upload-prescription-popup.component.scss']
})
export class UploadPrescriptionPopupComponent implements OnInit {

  @ViewChild('demo_prescription') demo_prescription: DemoPrescriptionComponent;

  public dataForm: FormGroup;
  user: User = null;
  files: File[];
  showHideDropdown: boolean = false;
  address: Address;

  //Subscriptions
  private subAddress: Subscription;
  private subDataOne: Subscription;
  private subDataTwo: Subscription;
  private subDataThree: Subscription;

  constructor(
    private uiService: UiService,
    public dialogRef: MatDialogRef<any>,
    private fb: FormBuilder,
    private userDataService: UserDataService,
    private fileUploadService: FileUploadService,
    private prescriptionOrderService: PrescriptionOrderService,
    private router: Router,
    private userService: UserService,
    private dialog: MatDialog,
    private reloadService: ReloadService,
      private utilsService: UtilsService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.getLoggedInUserInfo();

    this.subAddress = this.reloadService.geSelectedAddressData.subscribe((res) => {
      if (res) {
        this.address = res;
      }
    })
  }


  /**
 * INIT FORM
 */
  private initForm() {
    this.dataForm = this.fb.group({
      name: [null],
      phoneNo: [null, Validators.required],
      email: [null],
      description: [null],
    });
  }

  /**
   * HTTP REQ HANDLE
   */
  private getLoggedInUserInfo() {
    const select = 'phoneNo name profileImg email addresses';
    this.subDataOne = this.userDataService.getLoggedInUserData(select)
      .subscribe(res => {
        this.user = res.data;
        if (this.user) {
          this.dataForm.patchValue(this.user);
        }
      }, error => {
        console.log(error);
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //Get ImageFile
  onGetImageData(event: any) {
    this.files = event;
    console.log("this.files----------",this.files)
  }

  /**
 * ON IMAGE UPLOAD
 */
  onUploadImages() {
    if (this.address) {
      this.subDataTwo = this.fileUploadService.uploadMultiImageOriginal(this.files)
        .subscribe(res => {
          const downloadUrls = res.map((d) => d.url);
          const finalData = {
            ...this.dataForm.value,
            ...{
              images: downloadUrls,
              checkoutDate: this.utilsService.getDateString(new Date()),
              city: this.address.division?.name,
              district: this.address.area?.name,
              shippingAddress: this.address.address
            }
          };
          // console.log('finalData',finalData)
          this.placeOrder(finalData);
        }, error => {
          this.uiService.wrong('Upload Image Failed');
          console.log(error);
        });
    } else {
      this.uiService.warn('Please select your address');
    }
  }

  private placeOrder(data: PrescriptionOrder) {
    this.subDataThree = this.prescriptionOrderService.placeOrder(data)
      .subscribe(res => {
        if (res.success) {
          this.router.navigate(['/account/prescriptions']);
          this.uiService.success(res.message);
          this.onNoClick();
          this.reloadService.needRefreshData$();
        } else {
          this.uiService.warn(res.message);
        }
      }, error => {
        console.log(error);
      });
  }



  onUploadImg() {
    if (this.userService.getUserStatus()) {
      this.onUploadImages()
    } else {
      this.router.navigate(['/', 'login']);
      this.onNoClick();
    }
  }


  /**
   * onShowHideDropdown()
   * onShowHidePrescription()
   * onShowPrescriptionDemo()
  */
  onShowHideDropdown() {
    this.showHideDropdown = !this.showHideDropdown;
  }

  onShowPrescriptionDemo() {
    this.demo_prescription.onShowHideDemoPrescription();
  }

  openDialog() {
    this.dialog.open(AddressComponent, {
      maxWidth: "600px",
      minHeight: "450px",
      height: "auto",
      width: "100%"
    })
  }

  /**
   * NG ON DESTROY
   */

  ngOnDestroy() {
    if (this.subAddress) {
      this.subAddress.unsubscribe();
    }
    if (this.subDataOne) {
      this.subDataOne.unsubscribe();
    }
    if (this.subDataTwo) {
      this.subDataTwo.unsubscribe();
    }
    if (this.subDataThree) {
      this.subDataThree.unsubscribe();
    }
  }



}

